import { render, staticRenderFns } from "./MedicationNotes.vue?vue&type=template&id=4491b4a8&scoped=true"
import script from "./MedicationNotes.vue?vue&type=script&lang=js"
export * from "./MedicationNotes.vue?vue&type=script&lang=js"
import style0 from "./MedicationNotes.vue?vue&type=style&index=0&id=4491b4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4491b4a8",
  null
  
)

export default component.exports